import {prependForwardSlash, prependQuestionMark, QUESTION_MARK} from "../../../utils/string";
import {getFormattedDateForTitle} from "../../../utils/date";
import {RECORDING, RECORDING_ID_SHORTHAND, RECORDING_UNIT_SHORTHAND} from "../../../constants/routes";
import base64 from 'base-64';
import {parse, stringify} from "query-string";


/**
 * Formats a {@param recordingData} into a formatted
 * {@returns @type string} to be used for a recording's title.
 */
export const getFormattedRecordingTitle = (recordingData) => {
    if (recordingData.title) {
        return recordingData.title;
    } else {
        return getFormattedDateForTitle(recordingData.date);
    }
};

/**
 * Formats a {@param selectedUnit} and a
 * {@param recordingID} into a formatted
 * {@returns @type string} to be used for a
 * recording's sharing FULL route.
 */
export const getFormattedRouteForRecordingViewForSharing = (selectedUnit, recordingID) => {
    if (typeof window !== 'undefined') {
        return window.location.origin + getFormattedRouteForRecordingViewForEdit(selectedUnit, recordingID);
    } else {
        return "";
    }
};

/**
 * Formats a {@param selectedUnit}, a
 * {@param recordingID} and an optional
 * {@param queryObj} into a formatted
 * {@returns @type string} to be used for a
 * recording's edit domain specific route.
 */
export const getFormattedRouteForRecordingViewForEdit = (selectedUnit, recordingID, queryObj) => {
    return RECORDING +
        prependForwardSlash(getEncodedUnitRecordingRoute(selectedUnit, recordingID)) +
        (queryObj ? prependQuestionMark(stringify(queryObj)) : "");
};

/**
 * Formats a {@param currentPath}, and a
 * {@param queryObj} into a formatted
 * {@returns @type string} to be used for
 * a recording's edit domain but edit mode
 * set to false.
 */
export const getFormattedRouteForRecordingViewForView = (currentPath, queryObj) => {
    return currentPath + (queryObj ? prependQuestionMark(stringify(queryObj)) : "");
};

/**
 * Encodes a {@code unitID} and {@ recordingID} into
 * an encoded string to be decoded later for encoded
 * URL query parameters.
 *
 * TODO: Shorten hash.
 */
export const getEncodedUnitRecordingRoute = (selectedUnitID, recordingID) => {
    return base64.encode(QUESTION_MARK +
        RECORDING_UNIT_SHORTHAND + '=' + selectedUnitID + '&' +
        RECORDING_ID_SHORTHAND + '=' + base64.encode(recordingID)
    );
};

/**
 * Decodes an {@param encodedUrlString} into an object
 * containing children:
 *  - {@code unitID} and
 *  - {@code recordingID}
 *
 *  @throws InvalidCharacterError if url string is invalid.
 */
export const getDecodedUnitIDRecordingID = (encodedUrlString) => {
    try {
        const decodePass1 = base64.decode(encodedUrlString);
        const unitID = parse(decodePass1)[RECORDING_UNIT_SHORTHAND];
        const encodedRecordingID = parse(decodePass1)[RECORDING_ID_SHORTHAND];
        const decodePass2 = base64.decode(encodedRecordingID);
        return {
            unitID: unitID,
            recordingID: decodePass2
        };
    } catch(e) {
        if (e.name === 'InvalidCharacterError') {
            return {};
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/unit/recordings/utils.js